// extracted by mini-css-extract-plugin
export default {"invoiceActions":"open-status_invoiceActions__DPt2L","invoiceActionButton":"open-status_invoiceActionButton__P2CQy"};